import React from "react";
import { Box } from "@mui/material";
import Title from "./Title";
import Sentence from "./Sentence";

const Information = () => {
  // const addEventToAppleCalendar = () => {
  // const googleCalendarUrl = 'webcal://wedding-calender-files.s3.ap-northeast-1.amazonaws.com/event.ics';
  // window.open(googleCalendarUrl, '_blank');
  // const icsContent = `
  //   BEGIN:VCALENDAR
  //   VERSION:2.0
  //   CALSCALE:GREGORIAN
  //   BEGIN:VEVENT
  //   UID:123456789@example.com
  //   DTSTAMP:${new Date().toISOString().replace(/-|:|\.\d+/g, '')}
  //   DTSTART:20250923T020000Z
  //   DTEND:20250923T030000Z
  //   SUMMARY:輝征と玲乃の結婚式
  //   DESCRIPTION:予定の説明
  //   LOCATION:THINGS Aoyama Organic Garden. dth
  //   BEGIN:VALARM
  //   TRIGGER:-P1W
  //   ACTION:DISPLAY
  //   DESCRIPTION:1週間前のリマインダー
  //   END:VALARM
  //   BEGIN:VALARM
  //   TRIGGER:-P1D
  //   ACTION:DISPLAY
  //   DESCRIPTION:1日前のリマインダー
  //   END:VALARM
  //   END:VEVENT
  //   END:VCALENDAR
  // `
  //   .replace(/^\s+/gm, '') // 各行の先頭の空白やタブを削除
  //   .trim(); // 先頭と末尾の空白を削除
  // const blob = new Blob([icsContent], { type: 'text/calendar' });
  // const url = URL.createObjectURL(blob);
  // const link = document.createElement('a');
  // link.href = url;
  // link.download = 'event.ics';
  // document.body.appendChild(link);
  // link.click();
  // document.body.removeChild(link);
  // };

  // const addEventToGoogleCalendar = () => {
  //   const title = encodeURIComponent("輝征と玲乃の結婚式");
  //   const details = encodeURIComponent("QRコードを提示してください。\n場所: THINGS Aoyama Organic Garden. dth");
  //   const location = encodeURIComponent("東京都港区南青山4丁目10-15");
  //   const start = "20250923T110000"; // 日本時間での開始時刻（12:00 JST）
  //   const end = "20250923T130000";   // 終了時刻（14:00 JST）

  //   const url = `https://www.google.com/calendar/render?action=TEMPLATE&text=${title}&details=${details}&location=${location}&dates=${start}/${end}`;

  //   window.open(url, '_blank');
  // };

  // const addEventToCalendar = () => {

  //     const isAndroid = /android/i.test(navigator.userAgent);
  //     if (isAndroid) {
  //       // const intentUrl = `intent://${window.location.href.replace(/^https?:\/\//, '')}#Intent;scheme=https;package=com.android.chrome;end`;
  //       // window.location.href = intentUrl;
  //       addEventToGoogleCalendar(); // 上記の関数を呼ぶ
  //     } else {
  //       addEventToAppleCalendar();
  //     }

  // }

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      sx={{ backgroundColor: "#fbf9f3" }} // 背景色を設定
    >
      <Box
        sx={{
          padding: 4,
          display: "inline-block", // コンテンツに合わせて横幅を調整
          textAlign: "center",
          margin: "0 auto", // 親Boxを中央寄せ
        }}
      >
        {/* Title コンポーネントで「Information」を表示 */}
        <Title>Information</Title>

        <Box sx={{ p: 1 }}></Box>

        <Sentence>
          当日は挙式よりご列席くださいますようご案内申し上げます
        </Sentence>
        <Box sx={{ p: 2 }}></Box>

        {/* Information セクションの内容 */}
        {/* <Sentence sx={{ textAlign: "left" }}>
          <strong>日時</strong>　令和7年9月23日（祝・火）
        </Sentence> */}

        {/* <Sentence sx={{ textAlign: "left" }}>
          <strong>受付開始</strong>　　午後1時30分
        </Sentence>
        <Sentence sx={{ textAlign: "left" }}>
          <strong>挙式</strong>　　　　午後2時00分
        </Sentence>
        <Sentence sx={{ textAlign: "left" }}>
          <strong>披露宴</strong>　　　午後3時00分
        </Sentence>
        <Sentence sx={{ textAlign: "left" }}>
          <strong>お開き予定</strong>　　午後5時30分
        </Sentence> */}
        <Sentence
          sx={{
            display: "flex",
            justifyContent: "space-between",
            textAlign: "left",
          }}
        >
          日時
          <span>令和7年9月23日（祝・火）</span>
        </Sentence>

        <Sentence
          sx={{
            display: "flex",
            justifyContent: "space-between",
            textAlign: "left",
          }}
        >
          受付開始
          <span>午後1時30分</span>
        </Sentence>
        <Sentence
          sx={{
            display: "flex",
            justifyContent: "space-between",
            textAlign: "left",
          }}
        >
          挙式
          <span>午後2時00分</span>
        </Sentence>
        <Sentence
          sx={{
            display: "flex",
            justifyContent: "space-between",
            textAlign: "left",
          }}
        >
          披露宴
          <span>午後3時00分</span>
        </Sentence>
        <Sentence
          sx={{
            display: "flex",
            justifyContent: "space-between",
            textAlign: "left",
          }}
        >
          お開き予定
          <span>午後5時30分</span>
        </Sentence>

        <Sentence
          sx={{
            display: "flex",
            justifyContent: "space-between",
            textAlign: "left",
          }}
        >
          式場
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.things-aoyama.com/"
          >
            THINGS Aoyama Organic Garden. dth
          </a>
        </Sentence>

        <Sentence
          sx={{
            display: "flex",
            justifyContent: "space-between",
            textAlign: "left",
          }}
        >
          式場電話番号<span>03-3470-3555</span>
        </Sentence>

        <Sentence
          sx={{
            display: "flex",
            justifyContent: "space-between",
            textAlign: "left",
          }}
        >
          式場住所{" "}
          <span>
            〒107-0062 <br />
            東京都港区南青山4丁目10-15
          </span>
        </Sentence>

        <Box sx={{ mt: 2 }}>
          <iframe
            title="map"
            src="https://www.google.com/maps?q=THINGS+Aoyama+Organic+Garden.+dth&output=embed"
            width="100%"
            height="300"
            style={{ border: 0, borderRadius: 8 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </Box>

        <Sentence sx={{ textAlign: "left", mt: 2 }}>
          表参道駅 A4出口が最寄りですが
          <br /> エレベーター・エスカレーターはB3出口にございます
        </Sentence>
      </Box>
    </Box>
  );
};

export default Information;
